import * as css from './mobile.scss';
import {
  toggleClass,
  wrapLinkWithBiEvent,
  parseURI,
  setAttributes,
  removeAttributes,
  $, $$
} from '../../utils';
import {domains} from '../../data/constants.json';
import * as bi from '../../bi';

export const radioInputName = `marketing-header-and-footer-state-${Math.random().toString(36).substr(2)}`;

const setModal = id => {
  const root = $(`.${css.sections}`);
  const switchTo = $(`#${id}-section`);
  const attributes = {
    'aria-labeledby': `${id}-label`,
    'aria-describedby': `${id}-main`
  };

  $$(`.${css.section}`).forEach(section => section.setAttribute('aria-hidden', 'true'));
  if (id === css.allClosed) {
    removeAttributes(root, attributes);
    root.setAttribute('aria-hidden', 'true');
  } else {
    setAttributes(root, attributes);
    root.removeAttribute('aria-hidden');
  }
  if (switchTo) {
    switchTo.removeAttribute('aria-hidden');
  }
  setTimeout(() => {
    $(`#${id}-label`).focus();
  }, 1100);
};

export function bindStateChangeListener() {
  $$(`.${css.container} input[name="${radioInputName}"]`)
    .forEach(element => element.addEventListener('change', event => {
      const {id} = event.target;
      toggleClass(document.body, css.marketingHeaderAndFooterFixedBody, id !== css.allClosed);
      setModal(id);
    }
    ));
  return this;
}

export function markCurrentMenuItem() {
  const link = $(`.${css.section} .${css.menuItem} a[href$="${location.pathname}"]`);
  if (link) {
    toggleClass(link, css.active, true);
  }
  return this;
}

export function bindClicks() {
  $$(`.${css.section} .${css.menuItem} a`)
    .forEach(link => wrapLinkWithBiEvent(bi.mobileHeaderBiLogger, link, bi.mhConfig.menuPage, link => {
      const uri = parseURI(link.href);
      const name = link.dataset.biName ||
        (uri.hostname === domains.wix ? uri.pathname === '/' ? 'wix' : uri.pathname.substr(1) : uri.hostname);
      return {name};
    }));

  const signupLink = $(`.${css.section}:first-child .${css.sectionHeader} a[rel=login]`);
  if (signupLink) {
    wrapLinkWithBiEvent(bi.mobileHeaderBiLogger, signupLink, bi.mhConfig.signinClick);
  }

  $$(`.${css.container} [data-bi]`)
    .forEach(element => {
      let [evid, params] = element.dataset.bi.split(':');
      params = params ? params.split(';').reduce((obj, param) => {
        const [key, value] = param.split('=');
        return Object.assign(obj, {[key]: value});
      }, {}) : {};
      const listener = () => bi.mobileHeaderBiLogger.log(Object.assign({evid}, params));
      element.addEventListener('click', listener);
      element.addEventListener('tap', listener);
    });

  const switcher = event => {
    const {switchTo} = event.currentTarget.dataset;
    const input = $(`#${switchTo}`);
    input.click();
  };
  $$(`.${css.container} [data-switch-to]`)
    .forEach(button => {
      button.addEventListener('click', switcher);
      button.addEventListener('tap', switcher);
    });
  return this;
}

export function preventSafariBackButtonCache() {
  if (navigator.platform === 'iPhone' && navigator.appVersion.indexOf('Safari') >= 0) {
    window.addEventListener('onpageshow',
      event => event.persisted ? $(`input[name="${radioInputName}"]`).click() : undefined);
  }
  return this;
}

export function addOriginParamToSignUpLink() {
  const signupLink = $('[data-hook=sign-up-link]');
  if (signupLink && signupLink.href && !signupLink.href.includes('originUrl')) {
    signupLink.href = signupLink.href.concat(`&originUrl=${encodeURIComponent(location.href)}`);
  }
}
